module.exports = __webpack_public_path__ + "static/media/icon-bottle.f7d98046.svg";